import { generateContext } from '@btime/react-contexts'
import React, { useCallback, useState, useContext } from 'react'

const { StateContext, ActionsContext, Provider } = generateContext()
export const useAccordionState = () => useContext(StateContext)
export const useAccordionActions = () => useContext(ActionsContext)

const AccordionHandler = ({ startsOpen, ...props }) => {
  const [open, setOpen] = useState(startsOpen)

  const toggle = useCallback(() => {
    setOpen(!open)
  }, [open])

  const state = {
    open
  }
  const actions = {
    setOpen,
    toggle
  }

  return <Provider state={state} actions={actions} {...props} />
}

export default AccordionHandler
